module.exports = "/images/user-red.svg?37a9924e1753c0afd9972b875e15f493";